import React from 'react'
import Billboard from "../../components/Billboard";
import Links from "./Links/Links";
import MarkdownContent from "./MarkdownContent";


const Industry = ({name}) => {
    if(!name) return null
    return (
        <div className="col-6">
            <div className="row">
                <div className="col-4 CaseStudy__faIcon">
                    <i className="fas fa-hand-holding-heart"></i>
                </div>
                <div className="col-8">
                    <div className="CaseStudy__subtitle">Industry</div>
                    <div>{name}</div>
                </div>
            </div>
        </div>
    )
}
const Location = ({name}) => {
    if(!name) return null
    return (
        <div className="col-6">
            <div className="row">
                <div className="col-4 CaseStudy__faIcon">
                    <i className="fas fa-map-marker-alt"></i>
                </div>
                <div className="col-8">
                    <div className="CaseStudy__subtitle">Location</div>
                    <div>{name}</div>
                </div>
            </div>
        </div>
    )
}
const Challenges = ({challenges}) => {
    if(!challenges) return null

    const challengeList = challenges.map((challenge, idx) => {
        return (
            <div className="CaseStudy__challenge" key={idx}>
                <h3>{challenge.title}</h3>
                <div className="CaseStudy--challengeDescription">
                    <MarkdownContent content={challenge.text} className='' />
                </div>
            </div>
        )
    })

    return  <div className="row">
                <div className="col-md-12">
                    <h2>The Challenges</h2>
                    {challengeList}
                </div>
            </div>

}


const TemplateWithVideo = ({frontmatter, html, fields}) => {


    const companyLogoUrl = fields.companyLogo ? fields.companyLogo.publicURL : undefined

    const videos = frontmatter.video.length ? frontmatter.video.map((item, idx) => {
        return (
            <>
                <div className="row" >
                    <div className="col-md-12">
                        <video width="100%" controls="controls">
                            <source src={item.url} type="video/mp4" />
                        </video>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12" style={{padding: "10px 0 30px 0"}}>
                        <div className="col-md-12 CaseStudy-Quote__name" style={{textAlign: "right"}}>{item.author}</div>
                        <div className="col-md-12 CaseStudy-Quote__role" style={{textAlign: "right"}}>{item.role}</div>
                    </div>
                </div>
            </>
        )
    }) : ''


    return (
        <>
            <Billboard className="Billboard--resources" color="white">
                <div className="Billboard__top">
                    <h1 className="Billboard__title">{frontmatter.title}</h1>
                    <div className="Billboard__lead">CASE STUDY</div>
                    <div className="Billboard__cta"/>
                </div>
            </Billboard>

            <div className="CaseStudy">

                <section className="section blogWrap">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-9">
                                <div className="row CaseStudy--twoColumns">
                                    <div className="col-md-5">
                                        <img src={companyLogoUrl} alt={frontmatter.company.name}
                                             className="img-thumbnail"/>
                                    </div>
                                    <div className="col-md-7 CaseStudy--rightColumnContainer">
                                        <h2>
                                            The Client
                                        </h2>
                                        <h3>
                                            {frontmatter.company.name}
                                        </h3>
                                        <div className="row">
                                            <Industry name={frontmatter.company.industry}/>
                                            <Location name={frontmatter.company.location}/>
                                        </div>
                                    </div>
                                </div>

                                {videos}

                                <div className="row">
                                    <div className="col-md-12 CaseStudy--companyDescription">
                                        <h3>
                                            About {frontmatter.company.name}
                                        </h3>
                                        <MarkdownContent content={frontmatter.company.description} />
                                    </div>
                                </div>
                                <article className="article">
                                    <div
                                        className="CaseStudy--html"
                                        dangerouslySetInnerHTML={{__html: html}}
                                    />
                                </article>
                            </div>

                            <div className="col-md-3">
                                <div className="blogSidebar">
                                    <Links/>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

            </div>


        </>
    )

}

export default TemplateWithVideo